import { of } from 'rxjs'
import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { VendorCreditsElasticSearchService } from 'src/services/data/vendor-credit-elastic.service'
import { prepareFiltersPayload, prepareVendorCreditsPayload } from './vendor-credit-view-filters.utils'
import { TOP_LEVEL_FILTERS } from 'src/components/vendor-credits/vendor-credits-list/vendor-credits-list.filters'
import { loadVendorCreditViews, loadVendorCreditViewsFailure, loadVendorCreditViewsSuccess, loadVendorCreditFilters, loadVendorCreditFiltersSuccess, loadVendorCreditFiltersFailure } from './vendor-credit-view.actions'

@Injectable()
export class VendorCreditViewEffects {
  private actions$ = inject(Actions)
  private toaster = inject(ToasterService)
  private elastic = inject(VendorCreditsElasticSearchService)


  loadVendorCreditViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadVendorCreditViews),
    map(action => ({
      action,
      payload: prepareVendorCreditsPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) =>
      this.elastic.search({ ...payload, calculate: action.calculate }).pipe(
        map(r => loadVendorCreditViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          vendorCreditViews: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch vendor credits', loadVendorCreditViewsFailure
      )))))

  loadVendorCreditFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadVendorCreditFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadVendorCreditFiltersSuccess({ tableKey, result })),
      catchError(error => of(loadVendorCreditFiltersFailure({ error }))),
    ))))
}